import { useMutation, useQuery, useQueryClient } from "react-query";
import { createPublicHoliday, deletePublicHoliday, fetchPublicHolidays, updatePublicHoliday, } from "@/features/publicHoliday/services/publicHolidayService";
const usePublicHolidays = (filters) => {
    const queryClient = useQueryClient();
    const queryKey = ["publicHolidays", filters];
    const { data, error, isLoading, refetch } = useQuery(queryKey, () => fetchPublicHolidays(filters), {
        keepPreviousData: true,
        enabled: Boolean(filters.year),
    });
    const createMutation = useMutation((payload) => createPublicHoliday(payload), {
        onSuccess: () => queryClient.invalidateQueries(["publicHolidays"]),
    });
    const updateMutation = useMutation(({ id, payload }) => updatePublicHoliday(id, payload), {
        onSuccess: () => queryClient.invalidateQueries(["publicHolidays"]),
    });
    const deleteMutation = useMutation((id) => deletePublicHoliday(id), {
        onSuccess: () => queryClient.invalidateQueries(["publicHolidays"]),
    });
    return {
        holidays: data?.holidays ?? [],
        filters: data?.filters,
        isLoading,
        error: error?.message ?? null,
        refetch,
        createHoliday: createMutation.mutateAsync,
        updateHoliday: updateMutation.mutateAsync,
        deleteHoliday: deleteMutation.mutateAsync,
    };
};
export default usePublicHolidays;
